import CIAppDemoRequest from "@/components/forms/ci-app-demo-request-form";
import { Component } from "@builder.io/sdk";

export const ciAppDemoRequestConfig: Component = {
  name: "CI App Demo Request",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "ci-app-demo-request",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Trusted Partner to Care Facilities Like Yours",
      helperText: "Heading text for the section",
    },
    {
      name: "subheading",
      type: "string",
      defaultValue:
        "Easily manage shifts, track time, and communicate with your care team—all from one app built for Facility Administrators.",
      helperText: "Subheading text for the section",
    },
    {
      name: "className",
      type: "string",
      helperText: "Additional CSS classes for the section",
      advanced: true,
    },
    {
      name: "backgroundColor",
      type: "string",
      enum: ["transparent", "orange-light"],
      defaultValue: "orange-light",
      helperText: "Background color of the section",
      advanced: true,
    },
    {
      name: "redirectUrl",
      type: "string",
      helperText:
        "URL to redirect to after successful form submission (e.g., thank you page or scheduling page)",
      defaultValue: "/thank-you",
    },
    {
      name: "testimonials",
      type: "list",
      helperText: "Testimonials to display",
      defaultValue: [
        {
          image: undefined,
          name: "Channing House",
          date: "APR 2025",
          stars: 5,
          text: "Requesting shifts is so much faster compared to calling Care Indeed directly. I can easily check the Shift Calendar to see what's already been requested and what's coming up. Having everything in one place really streamlines communication and makes the whole process more efficient.",
        },
        {
          image: undefined,
          name: "The Forum",
          date: "APR 2025",
          stars: 5,
          text: "The biggest benefit of CI App is being able to post shifts without needing to contact anyone. I can view schedules instantly, which is especially helpful for auditing. It's a more efficient way to manage staffing, and it really streamlines the entire process.",
        },
      ],
      subFields: [
        {
          name: "image",
          friendlyName: "Avatar",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
          helperText: "Image of the person giving the testimonial",
        },
        {
          name: "name",
          type: "string",
          helperText: "Name of the facility giving the testimonial",
        },
        {
          name: "date",
          type: "string",
          helperText: "Date of the testimonial (e.g., OCT 2024)",
        },
        {
          name: "stars",
          type: "number",
          defaultValue: 5,
          helperText: "Rating from 1-5 stars",
        },
        {
          name: "text",
          type: "richText",
          helperText: "Testimonial text content",
        },
      ],
    },
  ],
};

export default CIAppDemoRequest;
